import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import TrustedSellersArticle from "../pages/articles/trusted-sellers/page";
import ComparisonArticle from "../pages/articles/comparison/page";
import SafeBuyingArticle from "../pages/articles/safe-buying/page";
import SneakersArticle from "../pages/articles/sneakers/page";
import ShippingArticle from "../pages/articles/shipping/page";
import QcGuideArticle from "../pages/articles/qc-guide/page";
import PriceGuideArticle from "../pages/articles/price-guide/page";
import Updates2026Article from "../pages/articles/2026-updates/page";
import BeginnersArticle from "../pages/articles/beginners/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/how-to-use-allchinabuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-spreadsheet-trusted-sellers",
    element: <TrustedSellersArticle />,
  },
  {
    path: "/allchinabuy-spreadsheet-comparison",
    element: <ComparisonArticle />,
  },
  {
    path: "/allchinabuy-spreadsheet-safe-buying",
    element: <SafeBuyingArticle />,
  },
  {
    path: "/allchinabuy-spreadsheet-sneakers",
    element: <SneakersArticle />,
  },
  {
    path: "/allchinabuy-spreadsheet-shipping",
    element: <ShippingArticle />,
  },
  {
    path: "/allchinabuy-spreadsheet-qc-guide",
    element: <QcGuideArticle />,
  },
  {
    path: "/allchinabuy-spreadsheet-price-guide",
    element: <PriceGuideArticle />,
  },
  {
    path: "/allchinabuy-spreadsheet-2026-updates",
    element: <Updates2026Article />,
  },
  {
    path: "/allchinabuy-spreadsheet-beginners",
    element: <BeginnersArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;